/** Exigibilité TVA sur la facture d'achat (SYSCOHADA) — indépendante de la fiche fournisseur. */
export type RegimeTvaFactureAchat = "debits" | "encaissements";

export function normalizeRegimeTvaFactureAchat(v: string | null | undefined): RegimeTvaFactureAchat {
  return v === "encaissements" ? "encaissements" : "debits";
}

/** Pré-remplissage depuis `fournisseurs.tva_exigibilite` (mêmes libellés métier). */
export function regimeTvaFactureAchatDepuisFournisseur(
  tvaExigibilite: string | null | undefined
): RegimeTvaFactureAchat {
  return tvaExigibilite === "encaissements" ? "encaissements" : "debits";
}

export function labelExigibiliteTvaFactureAchat(r: RegimeTvaFactureAchat): string {
  return r === "encaissements" ? "TVA sur encaissements" : "TVA sur débits";
}
